import React, { useState } from 'react'

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

import { PostCity } from '../../../../MyApi/sb/cites'

import PageHeader from '../../../../Components/UI/PageHeader'
import AddCity from '../../../../Components/sb/cites/citesStore/AddCity'



const CitesStore = () => {
const [cityName ,setCityName]= useState("")
const [countryId ,setCountryId]= useState("")
const {i18n}=useTranslation()
const lang =i18n.language
 const mutation = useMutation(["postCites",lang ], (postData)=>PostCity(postData,lang) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setCityName("")

    },
    onError:(error)=>{
       toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        name:cityName,     
        sb_country_id:countryId,
    })
 }
 const isDisabled= ()=>{
    return !(cityName && countryId )
 }
  return ( 

    <div>
        <PageHeader title="Add city" showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddCity cityName={cityName} setCityName={setCityName} setCountryId={setCountryId} />
    </div>
  )
}

export default CitesStore